import { PREFECTURE_CODES, PrefectureValue } from '@/constants/prefectures';
import { useTranslations } from 'next-intl';
import { useMemo } from 'react';

export function usePrefectureOptions(): {
  prefectureOptions: { value: PrefectureValue; label: string }[];
} {
  const t = useTranslations('common');

  // Map prefecture codes to options for the prefecture dialog
  const prefectureOptions = useMemo(
    () =>
      PREFECTURE_CODES.map((code) => ({
        value: code,
        label: t(`prefecture.label.${code}`),
      })),
    []
  );

  return {
    prefectureOptions,
  };
}
